module.exports = __webpack_public_path__ + "static/img/planetBg1.6493c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet/planetBg1.png
// module id = +eOY
// module chunks = 1